import React, { useState, useEffect } from "react";
import "../../Responsive.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../../src/Components/Firebase/firebase";
import { signOut, onAuthStateChanged } from "firebase/auth";

function LearningNavbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // undefined = not checked yet, null = logged out, object = logged in
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser ?? null);
    });
    return () => unsubscribe();
  }, []);

  const closeMenu = () => setIsMenuOpen(false);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await signOut(auth);
      closeMenu();
      navigate("/learning");
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <div className="byb-nav">
      <Navbar
        expand="lg"
        className="new_byb top_header"
        expanded={isMenuOpen}
        onToggle={setIsMenuOpen}
      >
        <span className="blur"></span>

        <Container>
          {/* Keep your flex row ONLY for brand + toggle */}
          <div className="header_nav">
            <Navbar.Brand as={Link} to="/" onClick={closeMenu}>
              <img
                src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/logo.svg"
                alt="BYB Logo"
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="learning-navbar-nav" />
          </div>

          {/* Collapse must be OUTSIDE header_nav */}
          <Navbar.Collapse id="learning-navbar-nav">
            <Nav className="ms-auto">
              {user === undefined ? null : user ? (
                <Link to="#" onClick={handleLogout} className="logout">
                  Logout
                </Link>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="sign_menu text-decoration-none"
                    onClick={closeMenu}
                  >
                    Sign In
                  </Link>

                  <Link
                    to="/signup"
                    className="text-decoration-none"
                    onClick={closeMenu}
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default LearningNavbar;
